(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/serversidehelper/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/app/serversidehelper/assets/javascripts/prescript.js'); 
(function(_, svs) {
  'use strict';

  svs.app = svs.app || {};
  svs.app.ServerSideHelper = svs.app.ServerSideHelper || {};
  svs.app.ServerSideHelper.utils = svs.app.ServerSideHelper.utils || {};
  svs.app.behaviors = svs.app.behaviors || {};
  svs.app.ServerSideHelper.logger = new svs.core.log.Logger(
    'app:ServerSideHelper'
  );
})(this._, this.svs);

 })(window);